import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Project } from '../project';
import { ProjectService } from '../project.service';
import { PlasterService } from '../plaster.service';
import { Plaster } from '../plaster';
import jspdf from 'jspdf';
import html2canvas from 'html2canvas';
@Component({
  selector: 'app-print-project-summary',
  templateUrl: './print-project-summary.component.html',
  styleUrls: ['./print-project-summary.component.sass']
})
export class PrintProjectSummaryComponent implements OnInit {
  project: Project = null;
  plaster: Plaster;

  @ViewChild('content') content: ElementRef;
  constructor(private projectService: ProjectService, private plasterService: PlasterService) { }

  ngOnInit() {
    this.project = this.projectService.getProject();
    this.plaster = this.plasterService.getKnaufPlaster(this.projectService.getSelectedKnaufPlaster());
  }

  downloadPdf() {
    var data = document.getElementById('content');
    html2canvas(data).then(canvas => {
      // Few necessary setting options
      document.body.appendChild(canvas)
      var imgWidth = 190;
      var imgHeight = canvas.height * imgWidth / canvas.width;
      // console.log(canvas);
      // console.log(imgWidth, imgHeight);
      const contentDataURL = canvas.toDataURL('image/jpeg')
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      pdf.addImage(contentDataURL, 'JPEG', 10, 10, imgWidth, imgHeight)
      pdf.save('kauf-projekt.pdf'); // Generated PDF
    });
  }
}
